import { render, staticRenderFns } from "./staffEntry.vue?vue&type=template&id=8927b2b0&scoped=true&"
import script from "./staffEntry.vue?vue&type=script&lang=js&"
export * from "./staffEntry.vue?vue&type=script&lang=js&"
import style0 from "./staffEntry.vue?vue&type=style&index=0&id=8927b2b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8927b2b0",
  null
  
)

export default component.exports